import { render, staticRenderFns } from "./CdcDetails.vue?vue&type=template&id=5fada4df&"
import script from "./CdcDetails.vue?vue&type=script&lang=js&"
export * from "./CdcDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports